import Iodine from '@caneara/iodine';
import { DateTime } from 'luxon';
import intlTelInput from 'intl-tel-input';

import { sleep, buttonFlow } from '../helpers/utils';

let forms = new Map();
const iodine = new Iodine();
const injectClass = 'validation-injected';

iodine.rule('slug', (value) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value));
iodine.rule('countMin', (value, param) => (Array.isArray(value) && value.length >= +param ? true : false));
iodine.rule('hasChecked', (value, param) => document.querySelector('input[name="' + param + '"]:checked') != null);
iodine.rule('slugCheck', (value, param) => document.querySelector('input[name="' + param + '"]:checked') != null);
iodine.rule('password', (value, param) => /^(?=.*[0-9])(?=.*[a-z]).{8,}$/.test(value));
iodine.rule('passwordEquals', (value, param) => document.querySelector(`input${param}`).value === value);
iodine.rule('mobile', (value, param) => {
    const el = document.querySelector(`input${param}`);

    if (el) {
        const iti = window.intlTelInputGlobals.getInstance(el);

        return iti.isValidNumber();
    }

    return false;
});

iodine.rule('dateFuture', (value, fmt) => {
    const now = DateTime.now();
    const input = DateTime.fromFormat(value, fmt);
    return (
        input.isValid &&
        input.startOf('year') >= now.startOf('year') &&
        input.startOf('month') >= now.startOf('month') &&
        input.startOf('day') >= now.startOf('day')
    ); // input >= now;
});
iodine.rule('time', (value) => DateTime.fromFormat(value, 'HH:mm').isValid);
iodine.rule('equals', (value, param) => `${value}`.trim() === $(param).val().trim());

iodine.setErrorMessage('required', '此欄位為必填');
iodine.setErrorMessage('slug', '格式錯誤');
iodine.setErrorMessage('countMin', '至少需要填入ㄧ個');
iodine.setErrorMessage('hasChecked', '至少需要選擇ㄧ個');
iodine.setErrorMessage('slugCheck', '[PARAM] 已被使用');
iodine.setErrorMessage('maxLength', '超過最大字數（[PARAM]）限制');
iodine.setErrorMessage('minLength', '請輸入最少 [PARAM] 字數');
iodine.setErrorMessage('dateFuture', '請選擇未來的時間');
iodine.setErrorMessage('time', '時間格式錯誤');
iodine.setErrorMessage('password', '密碼格式錯誤');
iodine.setErrorMessage('email', '無效的電子郵件格式');
iodine.setErrorMessage('equals', '此欄位內容輸入錯誤');
iodine.setErrorMessage('passwordEquals', '輸入的密碼沒有相同');
iodine.setErrorMessage('mobile', '格式錯誤');

const s4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};

const buildRulesCollection = (inputs) => {
    let collection = {};
    inputs.each(function () {
        const input = $(this);
        const name = input.prop('name');
        const rule = input.data('rules').split('|');

        collection[name] = rule;
    });

    return collection;
};

const buildValuesCollection = (inputs) => {
    let collection = {};
    inputs.each(function () {
        const input = $(this);
        const name = input.prop('name');
        const value = input.val();

        collection[name] = value;
    });

    return collection;
};

const toggleInputValidStatus = (input, result) => {
    if (result.valid === false) {
        input.toggleClass('is-invalid', true);
        input.toggleClass('is-valid', false);
    } else {
        input.toggleClass('is-invalid', false);
        input.toggleClass('is-valid', true);
    }

    if (input.is('.no-valid')) {
        input.toggleClass('is-valid', false);
    }
};

const validFormValue = (inputs, rules, btn = null) => {
    const values = buildValuesCollection(inputs);
    const result = iodine.assert(values, rules);

    if (btn !== null) {
        if (result.valid === true) {
            btn.reset();
        } else {
            btn.lock();
        }
        // btn.prop('disabled', !(result.valid === true));
    }

    return result;
};

export default function (Alpine) {
    Alpine.directive('validation', (el, { expression, value }, { evaluateLater, evaluate, effect, cleanup }) => {
        forms.set(el, { fields: {}, valid: null });

        const ta = $(el);
        ta.toggleClass(injectClass, true);

        let inputs = ta.find('[data-rules]');
        let rules = buildRulesCollection(inputs);

        const submit = ta.find('button[type=submit],.js-submit');
        const turnstileElement = ta.find('.cf-turnstile');
        const withTurnstile = turnstileElement.length > 0 && typeof turnstile !== 'undefined';
        const onChange = evaluate(el.dataset.onChange ?? '() => () => false');
        const beforeSubmit = evaluate(el.dataset.beforeSubmit ?? '() => (done) => done()'); // ta.data('before-submit');

        const button = buttonFlow(submit);
        let changeBuffer = null;

        button.lock();

        let turnstileId = null;
        let withToken = false;

        if (withTurnstile) {
            let options = {
                sitekey: import.meta.env.VITE_TURNSTILE_SITE_KEY,
                theme: 'light',
                size: 'normal',
                // action: value,
                callback: (token) => {
                    const expData = ta.attr('x-data');
                    withToken = true;
                    evaluate(`${turnstileElement.data('token')} = '${token}'`);
                },
                'expired-callback': () => {
                    withToken = false;
                },
                'timeout-callback': () => {
                    withToken = false;
                },
            };

            if (value) {
                options.action = value;
            }

            turnstileId = turnstile.render(turnstileElement.get(0), options);
        }

        const onchange = function (event) {
            clearTimeout(changeBuffer);
            changeBuffer = setTimeout(() => {
                event.preventDefault();

                const result = validFormValue(inputs, rules, button);

                const input = $(this);
                const name = input.prop('name');

                forms.set(el, result);

                ta.trigger(`validationMessage::${name}`);

                if (typeof onChange === 'function') {
                    onChange();
                }

                toggleInputValidStatus(input, result.fields[name]);
            }, 500);
        };

        inputs.off('change blur input').on('change blur input', onchange);

        ta.on('submit', function (e) {
            e.preventDefault();

            const result = validFormValue(inputs, rules, button);
            button.loading();

            forms.set(el, result);

            const done = async (success = true) => {
                if (success) {
                    await evaluate(expression);

                    sleep(2000).then(() => {
                        button.done();
                    });
                } else {
                    button.reset();
                }
            };

            if (result.valid !== true || (withTurnstile && withToken === false)) {
                for (const name in result.fields) {
                    if (result.fields[name].valid !== true) {
                        ta.trigger(`validationMessage::${name}`);
                    }
                }

                button.reset();

                return false;
            }

            if (withTurnstile) {
                withToken = false;
                turnstile.reset(turnstileId);
            }

            if (typeof beforeSubmit === 'function') {
                beforeSubmit(done);
            } else {
                done();
            }
        });

        $(window)
            .on('validation::update', () => {
                inputs = ta.find('[data-rules]');
                inputs.off('change blur').on('change blur', onchange);
                rules = buildRulesCollection(inputs);
            })
            .on('validation::reset', () => {
                if (withTurnstile) {
                    withToken = false;
                    turnstile.reset(turnstileId);
                }
            })
            .on('validation::on::change', () => {
                if (typeof onChange === 'function') {
                    onChange();
                }
            });

        sleep(700).then(() => {
            validFormValue(inputs, rules, button);
        });

        cleanup(() => {
            ta.off('submit');
            inputs.off('change');

            $(window).off('validation::update validation::on::change');

            forms.delete(el);
        });
    });

    Alpine.directive(
        'validation-message',
        (el, { expression, value }, { evaluateLater, evaluate, effect, cleanup }) => {
            const ta = $(el);
            const form = ta.closest(`.${injectClass}`);

            form.on(`validationMessage::${expression}`, () => {
                const result = forms.get(form.get(0));
                const valid = result.fields && result.fields[expression] ? result.fields[expression].valid : true;

                if (result.fields && result.fields[expression]) {
                    if (valid === false) {
                        ta.html(result.fields[expression].error).show();
                    } else {
                        ta.html('').hide();
                    }
                }
            });

            cleanup(() => {
                form.off(`validationMessage::${expression}`);
            });
        }
    );
}
